<template>
    <div class="container py-5">
        <h2>{{ $t('settings') }}</h2>
        <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'projects' }">
                            {{ $t('home') }}    
                        </router-link>
                    </li>
                    <li v-if="this.$route.name === 'projects'" class="breadcrumb-item">
                        {{ $t('projects') }}
                    </li>
                    <li v-else-if="this.$route.name === 'users'" class="breadcrumb-item">
                        {{ $t('users') }}
                    </li>
                    <li v-else-if="this.$route.name === 'groups'" class="breadcrumb-item">
                        {{ $t('groups') }}
                    </li>
                    <li v-else-if="this.$route.name === 'forms'" class="breadcrumb-item">
                        {{ $t('forms') }}
                    </li>
                </ol>
            </nav>
        <div class="row">   
            <div class="col-3">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <router-link to="/settings/projects" v-bind:class="['nav-link', activeProjects]" id="projects" 
                        data-toggle="pill" href="#projects" role="tab" aria-controls="projects" aria-selected="false">
                        {{ $t('projects') }}
                    </router-link>
                    <router-link to="/settings/users" id="users" data-toggle="pill" href="#users" 
                        role="tab" aria-selected="true" v-bind:class="['nav-link', activeUsers]" >
                        {{ $t('users') }}
                    </router-link>
                    <router-link to="/settings/groups" v-bind:class="['nav-link', activeGroups]" id="groups" 
                        data-toggle="pill" href="#groups" role="tab" aria-controls="groups" aria-selected="false">
                        {{ $t('groups') }}
                    </router-link>
                    <router-link to="/settings/forms" v-bind:class="['nav-link', activeForms]" id="forms" 
                        data-toggle="pill" href="#forms" role="tab" aria-controls="forms" aria-selected="false">
                        {{ $t('forms') }}
                    </router-link>
                </div>
            </div>
            <div class="col-9">
                <div class="tab-content" id="v-pills-tabContent">
                <router-view></router-view>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserApi from "../../api/server/user";

export default {
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.list = await UserApi.list();
            this.checkIfActive();
        },
        checkIfActive() {
            var self = this;
            if(self.$route) {
                if(self.$route.name === "users") {
                    self.activeUsers = "active"
                } else if (self.$route.name === "groups") {
                    self.activeGroups = "active"
                } else if (self.$route.name === "projects") {
                    self.activeProjects = "active"
                } else if (self.$route.name === "forms") {
                    self.activeForms = "active"
                }
            }
        }
    },
    data() {
        return {
            activeUsers: "",
            activeGroups: "",
            activeProjects: "",
            activeForms: "",
            list: []
        };
    }
};
</script>
